<template>
  <card card-body-classes="table-full-width">
    <template slot="header">
      <h4 class="card-title">{{ $t('posTransactionTable.title') }}
        <small v-if="filterDetails"
               class="ml-2 text-muted">{{ $t('posTransactionTable.subTitle', tableFilterLabelDetails) }}</small>
      </h4>
    </template>
    <div>
      <div
        class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
      >
        <el-select
          class="select-primary mb-3 pagination-select"
          v-model="pagination.perPage"
          placeholder="Per page"
        >
          <el-option
            class="select-primary"
            v-for="item in pagination.perPageOptions"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>

        <div class="row">
          <div class="col-6">
            <base-input>
              <el-input
                type="search"
                class="mb-3 search-input"
                prefix-icon="el-icon-search"
                :placeholder="$t('generic.searchInTablePlaceholder')"
                v-model="searchQuery"
                aria-controls="datatables"
              >
              </el-input>
            </base-input>
          </div>

        </div>
      </div>

      <el-table :data="queriedData" :row-class-name="tableRowClassName" :empty-text="$t('generic.noData')">
        <el-table-column type="expand">
          <template slot-scope="props">
            <pos-transaction-details :details="props.row"/>
          </template>
        </el-table-column>
        <el-table-column
          v-for="column in tableColumns"
          :key="column.label"
          :min-width="column.minWidth"
          :prop="column.prop"
          :label="$t(column.label)"
          :formatter="column.formatter"
        >
        </el-table-column>
        <el-table-column align="right" width="50">
          <div slot-scope="props">
            <router-link
              :to="{name: 'pos-transaction', params: {id: props.row.id}}">
              <i class="tim-icons icon-double-right"></i>
            </router-link>
          </div>
        </el-table-column>
      </el-table>
    </div>
    <div
      slot="footer"
      class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
      <div class="">
        <p class="card-category">
          {{ $t('generic.tablePaginationSummary', {from: from + 1, to: to, total: total}) }}
        </p>
      </div>
      <base-pagination
        class="pagination-no-border"
        v-model="pagination.currentPage"
        :per-page="pagination.perPage"
        :total="total"
      >
      </base-pagination>
    </div>
  </card>
</template>
<script>
import {Option, Select, Table, TableColumn} from 'element-ui';
import {BaseAlert, BasePagination} from 'src/components';
import Fuse from 'fuse.js';
import PosTransactionDetails from './PosTransactionDetails'

export default {
  name: 'posTransactionsTable',
  components: {
    BasePagination,
    BaseAlert,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    PosTransactionDetails
  },
  props: {
    details: {
      type: Array,
      required: true,
    },
    paginationDetails: {
      type: Object,
      required: true,
    },
    filterDetails: {
      type: Object,
      required: false,
    }
  },
  methods: {
    tableRowClassName({row}) {
      if (row["status"] === "failed") {
        return 'bg-warning';
      }
      return '';
    },
  },
  computed: {
    tableFilterLabelDetails: function () {
      return {
        date: this.$options.filters.dateOnly(this.filterDetails.date),
        txRef: decodeURIComponent(this.filterDetails.txRef)
      }
    },
    fuseSearch() {
      return new Fuse(this.details, {
        keys: this.propsToSearch,
        threshold: 0.3
      })
    },
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.details;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.details.length;
    }
  },
  data() {
    return {
      pagination: {
        perPage: 50,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      apiFilter: [],
      searchQuery: '',
      propsToSearch: ['transaction_reference'],
      tableColumns: [
        {
          prop: 'created_at',
          label: 'generic.created',
          formatter: (row, column, cellValue, index) => {
            return this.$options.filters.time(cellValue)
          },
        },
        {
          prop: 'status',
          label: 'generic.status',
        },
        {
          prop: 'processing_status',
          label: 'posTransactionDetails.processing_status',
        },
        {
          prop: 'distributor_id',
          label: 'posTransactionDetails.distributor_id',
        },
        {
          prop: 'transaction_reference',
          label: 'posTransactionDetails.transaction_reference',
        }
      ],
      searchedData: [],
    };
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.details;
      if (value !== '') {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    },
  }
};
</script>
<style scoped>
</style>
